// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"> <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M5.82 15H16v1H4.79l1.03-1zm6.628-15L16 3.195l-7.165 9.403-5.177-4.614L12.448 0zM3.253 8.749l4.904 4.362-3.01 1.09-2.711-2.406.817-3.046zm-.867 4.196l1.51 1.34L2.133 16 0 15.548l2.386-2.603z\"/> </svg> ";
// Exports
module.exports = code;